import React from 'react';
import { TextField } from '@mui/material';
import { Dialog } from '../../../../Components/MUIs';
import './LEG_BASIC_LawSelectDialog.styles.css';

/** 법규준수평가 — 신규법령 추가 팝업 */
function LEG_BASIC_NewLawDialog({
  open = false,
  value = '',
  onChange = () => {},
  onClose = () => {},
  onConfirm = () => {},
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="신규법령 추가"
      maxWidth="sm"
      fullWidth
      useSaveButton={true}
      useCloseButton={true}
      saveButtonName="확인"
      closeButtonName="취소"
      onSave={onConfirm}
      titleSx={{ pb: 1, fontWeight: 700, fontSize: 18 }}
      contentSx={{ pt: 4, px: 2.5, pb: 2.5 }}
      content={
        <div className="leg-law-select">
          <div className="leg-law-select__intro">
            <div className="leg-law-select__intro-icon">
              <span className="material-symbols-outlined">playlist_add</span>
            </div>
            <div>
              <div className="leg-law-select__intro-title">
                추가할 법령명을 입력하세요
              </div>
              <p className="leg-law-select__intro-desc">
                전기안전관리법, 위험물관리법, 소방시설법 등 사업장에 필요한
                법령 점검표를 새로 만들 수 있습니다.
              </p>
            </div>
          </div>

          <div className="leg-law-select__field">
            <label className="leg-law-select__field-label" htmlFor="leg-new-law-nm">
              법령명
            </label>
            <TextField
              id="leg-new-law-nm"
              fullWidth
              size="small"
              placeholder="예: 전기안전관리법"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onConfirm();
                }
              }}
              autoFocus
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  '& fieldset': {
                    borderColor: '#e8eaed',
                  },
                  '&:hover fieldset': {
                    borderColor: '#2CA900',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#2CA900',
                    borderWidth: '1.5px',
                  },
                },
              }}
            />
          </div>
        </div>
      }
    />
  );
}

export default LEG_BASIC_NewLawDialog;
